<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="select" label="模块类型" name="classify_type" :options="classifyType"></c-form-item>
                    <c-form-item type="input" label="模块名称" name="classify_name"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button icon="add" power="b_sns_classify_edit" color="sys" @click="addClassify()">新增</c-button>
            </m-operate>

            <c-table ref="table" code="sns_classify_list_1">

                <c-table-column
                        label="模块类型"
                        name="classify_type"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.classify_type == 1">分享</span>
                        <span v-if="data.classify_type == 2">话题</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="模块名称"
                        name="classify_name"
                        width="150"
                >
                </c-table-column>

               <c-table-column
                                label="状态"
                                name="is_valid"
                                width="80"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.is_valid == 1"><span style="color:darkgreen">启用</span></span>
                                <span v-if="data.is_valid != 1"><span style="color:#999999">禁用</span></span>
                            </template>
                        </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        name="sort_value"
                        @sort="sortHandle"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_sns_classify_edit" v-if="data.is_valid == 0"  @click="updateValid(1,data)">启用</c-table-button>
                        <c-table-button power="b_sns_classify_edit" v-if="data.is_valid == 1"  @click="updateValid(0,data)">禁用</c-table-button>
                        <c-table-button power="b_sns_classify_edit" @click="edit(data)">编辑</c-table-button>
                        <c-table-button power="b_sns_classify_edit"   @click="del(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

        <c-dialog ref="editDialog" :title="editState ? '编辑' : '新增'" width="600" @resolve="submitForm">
            <c-form ref="editForm">
                <c-form-item type="input" label="模块名称" name="classify_name" required></c-form-item>
                <c-form-item type="select" label="所属分类" name="classify_type" :options="classifyType" required></c-form-item>
                <c-form-item v-if="editId != 4" type="checkbox" label="是否启用" name="is_valid" :options="isValid"></c-form-item>
                <c-form-item type="hidden" name="id"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
    export default {
        name: 'm_sns_classify',

        components: {
        },

        data() {
            return {
                tagList: [],
                classifyType:[
                    {name:'话题',value:2},
                    {name:'分享',value:1}
                ],
                isValid: [{
                    name: '启用',
                    value: 1
                }],
                editState: false,
                editId: 0
            }
        },

        mounted() {
            this.$refs.search.search();
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/sns/classify/list',
                    data
                });
            },

            sortHandle(row, type, next) {
                //row.prev() 上一行数据
                //row.next() 下一行数据
                let submitData ={};
                if(type=='top' || type=='bottom'){
                    submitData.type = type;
                    submitData.id = row.data.id;
                }
                if(type=='up'){
                    submitData.id1 = row.data.id;
                    submitData.id2 = row.prev().data.id;
                }
                if(type=='down'){
                    submitData.id1 = row.data.id;
                    submitData.id2 = row.next().data.id;
                }
                this.request({
                    url: '/sns/classify/sort',
                    data: submitData,
                    loading: true,
                    success: data => {
                        next();
                    }
                });
            },

            addClassify() {
                this.editState = false;
                this.editId = 0;
                this.$refs.editForm.clear();
                this.$refs.editDialog.open();
            },

            edit(val) {
                this.editState = true;
                this.editId = val.id;
                this.$refs.editForm.set(val);
                this.$refs.editDialog.open();
            },

            del(val) {
                this.$confirm({
                    text: '确定要删除【'+val.classify_name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/sns/classify/delete',
                            data: {id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            submitForm(stop) {
                stop();
                let submitUrl = '/sns/classify/add';
                if(this.editState){
                    submitUrl = '/sns/classify/edit';
                }
                this.$refs.editForm.submit({
                    url: submitUrl,
                    rule: {
                        classify_name: [{
                            type: 'empty',
                            word: '请填写模块名称'
                        }],
                        classify_type: '请选择所属分类',
                    },
                    dataFormatter: data => {
                        data.is_valid = data.is_valid[0];
                        return data;
                    },
                    success:(data,res) => {
                        this.$message({
                            text: '操作成功',
                            icon: 'success'
                        });
                        this.$refs.table.update();
                        this.$refs.editDialog.close();
                    },
                });
            },

            updateValid(type,val) {
                this.$confirm({
                    text: '确定要'+(type==1?'启用':'禁用')+'【'+val.classify_name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/sns/classify/valid',
                            data: {id:val.id,valid:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            }
        }
    }
</script>